var methodList = ['editRow', 'saveRow', 'resetRow', 'validateRow', 'getDataSource'];
export default function buildNextTableMethod(instance) {
  methodList.forEach(function (name) {
    instance[name] = function () {
      var tableRef = instance.tableRef;
      var current = tableRef.current;
      if (current) {
        var method = current[name];
        if (method) {
          return method.apply(current, arguments);
        }
      }
    };
  });
}